import { CssBaseline, ThemeProvider } from "@material-ui/core";
import { default as React } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import "./App.css";
import "./index.css";
import { store } from "./store/Reducer";
import { theme } from "./Theme";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
